import React from 'react'

import { makeStyles } from '@mui/styles'

import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepButton from '@mui/material/StepButton'
import StepLabel from '@mui/material/StepLabel'
import Colors from 'utils/Colors'

import _ from 'lodash'
import { Connector, StepIndicator } from './styles'

export default function TimelineStepper(props) {
  const { steps, handleStep, activeStep, completed, formErrors } = props

  const classes = makeStyles(() => ({
    customButtonStyle: {
      padding: '24px 8px',
    },

    customAlternativeLabel: {
      marginTop: '4px !important',
    },

    customLabelStyle: {
      fontSize: '1rem',
    },
    active: {
      fontWeight: '600 !important',
      textShadow: `1px 1px 1px ${Colors.gray}`,
    },
  }))()

  const stepHasError = (label) => _.some(formErrors, fe => fe.stepName === label) 

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper
        nonLinear
        activeStep={activeStep}
        alternativeLabel
        connector={<Connector />}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton
              classes={{
                root: classes.customButtonStyle,
              }}
              color="inherit"
              onClick={handleStep(index)}
            >
              <StepLabel
                error={stepHasError(label)}
                classes={{
                  label: classes.customLabelStyle,
                  alternativeLabel: classes.customAlternativeLabel,
                  active: classes.active,
                }}
                StepIconComponent={StepIndicator}
              >
                {label}
              </StepLabel>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
